import axios from 'axios';
import {
    categoryRequest,
    categoriesSuccess,
    categoryCreateSuccess,
    categoryUpdateSuccess,
    categoryDeleteSuccess,
    categoryFail,
} from '../slices/categorySlice';

export const getCategories = () => async (dispatch) => {
    try {
        dispatch(categoryRequest());
        const { data } = await axios.get('/api/v1/admin/accounts/categories');
        dispatch(categoriesSuccess(data.rawCategories));
    } catch (err) {
        dispatch(categoryFail(err.response?.data?.message || 'Failed to load categories'));
    }
};

export const createCategory = (categoryData) => async (dispatch) => {
    try {
        dispatch(categoryRequest());
        const { data } = await axios.post('/api/v1/admin/accounts/categories', categoryData);
        dispatch(categoryCreateSuccess(data.category));
    } catch (err) {
        dispatch(categoryFail(err.response?.data?.message || 'Failed to create category'));
    }
};

export const updateCategory = (id, categoryData) => async (dispatch) => {
    try {
        dispatch(categoryRequest());
        const { data } = await axios.put(`/api/v1/admin/accounts/categories/${id}`, categoryData);
        dispatch(categoryUpdateSuccess(data.category));
    } catch (err) {
        dispatch(categoryFail(err.response?.data?.message || 'Failed to update category'));
    }
};

export const deleteCategory = (id) => async (dispatch) => {
    try {
        if (!id) {
            dispatch(categoryFail('Invalid category ID'));
            return;
        }
        dispatch(categoryRequest());
        await axios.delete(`/api/v1/admin/accounts/categories/${id}`);
        dispatch(categoryDeleteSuccess(id));
    } catch (err) {
        dispatch(categoryFail(err.response?.data?.message || 'Failed to delete category'));
    }
};
